import { controls } from "./formParts/AccrualPeriodFormCompensation";

export default function extractCompensationAccrualPeriod(formData: FormData): 'month' | 'quarter' {
  return formData.get(controls.accrualPeriod) as 'month' | 'quarter'
}
